export default __webpack_public_path__ + "static/media/successfully-animation.b7ae8cb7.gif";